import Outlined from '../div/Outlined'
import './responsibility.css';

const Responsibility = () => {
  return <div className='responsibilities'>
      <h1>What you should know</h1>
      <Outlined/>
      <div className='res--wrapper'>
          <div className='res'>
              <img src={require('../../assets/movie-copyright.png')} alt=''/>
              <h5>What are you rights</h5>
              <p>24/7 security</p>
              <p>Feedback for complains</p>
              <p>Deposit refund when moving out.</p>
          </div>
          <div className='res'>
              <img src={require('../../assets/user.png')} alt=''/>
              <h5>What are your responsibilities</h5>
              <p>Paying rent before the due dates</p>
              <p>Taking good care of the house or property</p>
              <p>Immediate reporting of any challenge or limitation experienced.</p>
          </div>
          <div className='res'>
              <img src={require('../../assets/user-relationship.png')} alt=''/>
              <h5>What are our responsibilities</h5>
              <p>Ensure 24/7 security</p>
              <p>Ensure your complains have been attend to</p>
              <p>Regular updates on issue concerning the house, room or property</p>
          </div>
      </div>
  </div>;
};

export default Responsibility;
